export const FINANCIAL_THRESHOLDS = {
	DEFAULT_STAKE: 50,

	MIN_STAKE: 2,
	MIN_BALANCE_FOR_PLACING_BET: 2,
	MIN_DEPOSIT_AMOUNT: 2,
	MAX_BALANCE_FOR_QUICK_TOP_UP: 2,

	MIN_PAYOUT: 10,

	MIN_AKO_BONUS_PERCENT: 2,
};
